class LoggerService {

    public static $inject: string[] = [];

    public logsStack;

    constructor() {
        this.logsStack = [];

        if (typeof localStorage !== "undefined" && localStorage.getItem("thorLog")) {
            angular.fromJson(localStorage.getItem("thorLog")).forEach(
                log => {
                    this.logsStack.push(log);
                }
            );
        }
    }

    public save () {
        if (typeof localStorage !== "undefined") {
            localStorage.setItem("thorLog", angular.toJson(this.logsStack.slice(0, 100)));
        }
    }

    public pushLog(log) {
        const formattedLog = {
            level: log.level,
            data: log.data,
            datetime: log.datetime
        };

        this.logsStack.push(formattedLog);
    }
}

angular
    .module("thor.core.logger.service", [])
    .service("loggerService", LoggerService);
